import { Component } from '@angular/core';
import { IconBase } from 'src/app/icons/icon.base';
import { IconConfig } from 'src/app/icons/icon.config';

@Component({
  selector: 'fit-tools-road-cone-icon',
  templateUrl: './tools-road-cone.component.html'
})
export class ToolsRoadConeComponent extends IconBase {

  constructor(config?: IconConfig) {
    super(config);
  }
}
